import type { QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { BrowserCompatibilityBanner } from "@/components/BrowserCompatibilityBanner";
import { env } from "@/env";

interface MyRouterContext {
	queryClient: QueryClient;
	userId: string | null;
	get_token: () => Promise<string | null>;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
	component: () => (
		<>
			<BrowserCompatibilityBanner />
			<Outlet />
			{env.VITE_APP_ENVIRONMENT === "local" && (
				<>
					<TanStackRouterDevtools position="bottom-left" />
					<ReactQueryDevtools buttonPosition="bottom-right" />
				</>
			)}
		</>
	),
});
